import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import {Icon} from "@blueprintjs/core";
import {List} from "immutable";
import numeral from 'numeral';
import moment from 'moment';

// Image
import image from '../assets/img/bg-login.jpg';

// Components
import Select from "../components/common/virtualized-select";
import VirtualizedTable from "../components/common/virtualized-table";

// Actions
import {getProjects, cleanProjects} from "../actions/projects";
import {getAlerts, changeStatusAlert, cleanAlerts} from "../actions/alerts";

// Numeral configuration
import 'numeral/locales/es-es';
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

class HomePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedAlertType: 'project_profit'
        };
    }
    componentDidMount() {
        this.props.getProjects({
            filters: { status: 'active' },
            projection: 'statistics',
            calculateStatistics: 'projects',
            calcIsAsync: true,
            deleteVirtuals: true
        });
        // this.props.getAlerts({ type: 'project_profit' });
        this.props.getAlerts();
    }
    componentWillUnmount() {
        this.props.cleanProjects();
        this.props.cleanAlerts();
    }

    onChangeAlertType = (alertTypeId) => {
        // this.props.getAlerts({ type: alertTypeId });
        this.setState({
            selectedAlertType: alertTypeId
        });
    };

    render() {
        // Project Stats
        let marginAvg = 0, costAvg = 0;
        this.props.projects.forEach(project => {
            marginAvg = marginAvg + project.getIn(['statistics', 'current_margin']);
            costAvg = costAvg + project.getIn(['statistics', 'current_total']);
        });
        marginAvg = marginAvg / this.props.projects.size;
        costAvg = costAvg / this.props.projects.size;

        // Alerts
        const alertOptions = [
            {id: 'stock', alertType: 'Stock'},
            {id: 'project_profit', alertType: 'Margen proyecto'},
            {id: 'product_price', alertType: 'Precio producto'}
        ];
        let tableSettings = {
            sortable: false,
            filterable: false,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: 164,
            rowHeight: 40,
            strippedRows: false,
            conditionalRowStyle: [{
                dataField: 'status',
                operation: '=',
                value: 'unread',
                style: {
                    backgroundColor: '#E8F1F7'
                }
            }],
        };
        let tableData = this.props.alerts.filter(alert => alert.get('type') === this.state.selectedAlertType);
        let tableColumns;
        switch (this.state.selectedAlertType) {
            case 'stock':
                tableColumns = {
                    createdAt: {
                        title: 'Fecha alerta',
                        columnType: 'function',
                        dataField: 'createdAt',
                        width: 150,
                        style: {},
                        sortable: false,
                        filterable: false,
                        nodeContent: (date) => moment(date).format('DD/MM/YYYY')
                    },
                    product: {
                        title: "Producto",
                        columnType: 'text',
                        dataField: 'data.product.name',
                        width: 200,
                        style: {},
                        sortable: false,
                        filterable: false
                    },
                    warehouse: {
                        title: "Almacén",
                        columnType: 'text',
                        dataField: 'data.warehouse.name',
                        width: 200,
                        style: {},
                        sortable: false,
                        filterable: false
                    },
                    security_stock: {
                        title: "Stock de seguridad",
                        columnType: 'text',
                        dataField: 'data.security_stock',
                        width: 130,
                        style: { color: '#1ab394', fontWeight: 'bold', textAlign: 'right' },
                        sortable: false,
                        filterable: false
                    },
                    total_amount: {
                        title: "Stock Total",
                        columnType: 'text',
                        dataField: 'data.total_amount',
                        width: 100,
                        style: { color: '#ED5565', fontWeight: 'bold', textAlign: 'right' },
                        sortable: false,
                        filterable: false
                    },
                    actions: {
                        title: '',
                        columnType: 'function',
                        dataField: ['_id', 'status'],
                        width: 100,
                        style: { alignItems: 'center', maxWidth: 100 },
                        sortable: false,
                        filterable: false,
                        nodeContent: (value) => {
                            return (
                                <div>
                                    { value[1] && value[1] === 'read'
                                        ? <Icon className="cursor-pointer" icon="eye-off" title="Marcar como no leída" onClick={() => {
                                            this.props.changeStatusAlert(value[0], 'unread');
                                        }} />
                                        : <Icon className="cursor-pointer" icon="eye-open" title="Marcar como leída" onClick={() => {
                                            this.props.changeStatusAlert(value[0], 'read');
                                        }} />
                                    }
                                    <Icon className="cursor-pointer ml-3" icon="trash" title="Archivar" onClick={() => {
                                        this.props.changeStatusAlert(value[0], 'archived');
                                    }} />
                                </div>
                            );
                        }
                    }
                };
                break;
            case 'project_profit':
                tableColumns = {
                    createdAt: {
                        title: 'Fecha alerta',
                        columnType: 'function',
                        dataField: 'createdAt',
                        width: 150,
                        style: {},
                        sortable: false,
                        filterable: false,
                        nodeContent: (date) => moment(date).format('DD/MM/YYYY')
                    },
                    project: {
                        title: "Proyecto",
                        columnType: 'text',
                        dataField: 'data.project.name',
                        width: 200,
                        style: {},
                        sortable: false,
                        filterable: false
                    },
                    target_margin: {
                        title: "Margen objetivo",
                        columnType: 'function',
                        dataField: 'data.target_margin',
                        width: 130,
                        style: { color: '#1ab394', fontWeight: 'bold', textAlign: 'right' },
                        sortable: false,
                        filterable: false,
                        nodeContent: (margin) => numeral(margin/100).format('0.00 %')
                    },
                    current_margin: {
                        title: "Margen",
                        columnType: 'function',
                        dataField: 'data.current_margin',
                        width: 100,
                        style: { color: '#ED5565', fontWeight: 'bold', textAlign: 'right' },
                        sortable: false,
                        filterable: false,
                        nodeContent: (margin) => numeral(margin/100).format('0.00 %')
                    },
                    actions: {
                        title: '',
                        columnType: 'function',
                        dataField: ['_id', 'status'],
                        width: 100,
                        style: { alignItems: 'center', maxWidth: 100 },
                        sortable: false,
                        filterable: false,
                        nodeContent: (value) => {
                            return (
                                <div>
                                    { value[1] && value[1] === 'read'
                                        ? <Icon className="cursor-pointer" icon="eye-off" title="Marcar como no leída" onClick={() => {
                                            this.props.changeStatusAlert(value[0], 'unread');
                                        }} />
                                        : <Icon className="cursor-pointer" icon="eye-open" title="Marcar como leída" onClick={() => {
                                            this.props.changeStatusAlert(value[0], 'read');
                                        }} />
                                    }
                                    <Icon className="cursor-pointer ml-3" icon="trash" title="Archivar" onClick={() => {
                                        this.props.changeStatusAlert(value[0], 'archived');
                                    }} />
                                </div>
                            );
                        }
                    }
                };
                break;
            case 'product_price':
                tableColumns = {
                    createdAt: {
                        title: 'Fecha alerta',
                        columnType: 'function',
                        dataField: 'createdAt',
                        width: 150,
                        style: {},
                        sortable: false,
                        filterable: false,
                        nodeContent: (date) => moment(date).format('DD/MM/YYYY')
                    },
                    product: {
                        title: "Producto",
                        columnType: 'text',
                        dataField: 'data.product.name',
                        width: 200,
                        style: {},
                        sortable: false,
                        filterable: false
                    },
                    last_price: {
                        title: "Último precio",
                        columnType: 'function',
                        dataField: 'data.last_price',
                        width: 130,
                        style: { color: '#1ab394', fontWeight: 'bold', textAlign: 'right' },
                        sortable: false,
                        filterable: false,
                        nodeContent: (price) => numeral(price).format('0,0.00000 $')
                    },
                    current_price: {
                        title: "Precio actual",
                        columnType: 'function',
                        dataField: 'data.current_price',
                        width: 100,
                        style: { color: '#ED5565', fontWeight: 'bold', textAlign: 'right' },
                        sortable: false,
                        filterable: false,
                        nodeContent: (price) => numeral(price).format('0,0.00000 $')
                    },
                    threshold: {
                        title: "Límite de aumento",
                        columnType: 'function',
                        dataField: 'data.threshold',
                        width: 130,
                        style: { color: '#ED5565', fontWeight: 'bold', textAlign: 'right' },
                        sortable: false,
                        filterable: false,
                        nodeContent: (threshold) => numeral(threshold/100).format('0.00 %')
                    },
                    real_increase: {
                        title: "Aumento real",
                        columnType: 'function',
                        dataField: 'data.real_increase',
                        width: 100,
                        style: { color: '#ED5565', fontWeight: 'bold', textAlign: 'right' },
                        sortable: false,
                        filterable: false,
                        nodeContent: (real_increase) => numeral(real_increase/100).format('0.00 %')
                    },
                    actions: {
                        title: '',
                        columnType: 'function',
                        dataField: ['_id', 'status'],
                        width: 100,
                        style: { alignItems: 'center', maxWidth: 100 },
                        sortable: false,
                        filterable: false,
                        nodeContent: (value) => {
                            return (
                                <div>
                                    { value[1] && value[1] === 'read'
                                        ? <Icon className="cursor-pointer" icon="eye-off" title="Marcar como no leída" onClick={() => {
                                            this.props.changeStatusAlert(value[0], 'unread');
                                        }} />
                                        : <Icon className="cursor-pointer" icon="eye-open" title="Marcar como leída" onClick={() => {
                                            this.props.changeStatusAlert(value[0], 'read');
                                        }} />
                                    }
                                    <Icon className="cursor-pointer ml-3" icon="trash" title="Archivar" onClick={() => {
                                        this.props.changeStatusAlert(value[0], 'archived');
                                    }} />
                                </div>
                            );
                        }
                    }
                };
                break;
            default:
                break;
        }

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center" style={{ height: 35 }} >
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item active">
                                <strong>Inicio</strong>
                            </li>
                        </ol>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row ibox">
                        <div
                            className="col home-image pl-0 pr-0"
                            style={{
                                background: `url(${image}) center no-repeat`,
                                marginLeft: 15,
                                marginRight: 15,
                                borderRadius: 3
                            }}
                        >
                        </div>
                        <div className="col-auto d-flex flex-column">
                            <span className="font-weight-bold">Compras</span>
                            <hr className="mt-1 mb-2" />
                            <button
                                className="btn btn-primary mb-3"
                                onClick={ () => this.props.history.push('/compras/proveedores/nuevo') }
                            ><Icon icon="insert"/>Proveedor</button>
                            <button
                                className="btn btn-primary mb-3"
                                onClick={ () => this.props.history.push('/compras/pedidos/nuevo') }
                            ><Icon icon="insert"/>Pedido de Compra</button>
                            <button
                                className="btn btn-primary mb-3"
                                onClick={ () => this.props.history.push('/compras/albaranes/nuevo') }
                            ><Icon icon="insert"/>Albarán de Entrada</button>
                            <button
                                className="btn btn-primary mb-3"
                                onClick={ () => this.props.history.push('/compras/facturas/nuevo') }
                            ><Icon icon="insert"/>Factura de Compra</button>
                            <span className="font-weight-bold">Ventas</span>
                            <hr className="mt-1 mb-2" />
                            <button
                                className="btn btn-primary mb-3"
                                onClick={ () => this.props.history.push('/ventas/clientes/nuevo') }
                            ><Icon icon="insert"/>Cliente</button>
                            <button
                                className="btn btn-primary mb-3"
                                onClick={ () => this.props.history.push('/ventas/escandallos/nuevo') }
                            ><Icon icon="insert"/>Escandallo de Costes</button>
                            <button
                                className="btn btn-primary mb-3"
                                onClick={ () => this.props.history.push('/ventas/presupuestos/nuevo') }
                            ><Icon icon="insert"/>Presupuesto de Venta</button>
                            <button
                                className="btn btn-primary mb-3"
                                onClick={ () => this.props.history.push('/ventas/pedidos/nuevo') }
                            ><Icon icon="insert"/>Pedido de Venta</button>
                            <button
                                className="btn btn-primary mb-3"
                                onClick={ () => this.props.history.push('/ventas/albaranes/nuevo') }
                            ><Icon icon="insert"/>Albarán de Salida</button>
                            <button
                                className="btn btn-primary"
                                onClick={ () => this.props.history.push('/ventas/facturas/nuevo') }
                            ><Icon icon="insert"/>Factura de Venta</button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-4">
                            <div className="ibox last-row">
                                <div className="ibox-title">
                                    <h5>Proyectos</h5>
                                </div>
                                <div className="ibox-content projects">
                                    <h2 className="font-bold">{ this.props.projects.size }</h2>
                                    <h4 className="text-muted">Proyectos en curso</h4>
                                    <h2 className="font-bold" style={{ color: '#1ab394' }} >{ numeral(marginAvg/100).format('0,0.00 %') }</h2>
                                    <h4 className="text-muted">Margen promedio</h4>
                                    <h2 className="font-bold text-danger">{ numeral(costAvg).format() }</h2>
                                    <h4 className="text-muted" >Coste promedio</h4>
                                    <button
                                        className="btn btn-primary"
                                        onClick={ () => this.props.history.push('/proyectos/nuevo') }
                                    > <Icon icon="insert"/>Proyecto</button>
                                </div>
                            </div>
                        </div>
                        <div className="col-8">
                            <div className="ibox last-row">
                                <div className="ibox-title">
                                    <h5>Alertas</h5>
                                </div>
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col">
                                            <p>Total: <strong>{ this.props.alerts.size }</strong> alertas</p>
                                            <p>Mostrando: <strong>{ tableData.size }</strong> alertas</p>
                                        </div>
                                        <div className="col d-flex justify-content-end">
                                            <Select
                                                style={{ width: 150 }}
                                                options={alertOptions}
                                                value={this.state.selectedAlertType}
                                                labelKey='alertType'
                                                valueKey='id'
                                                matchProp='alertType'
                                                multi={false}
                                                searchable={false}
                                                clearable={false}
                                                onChange={(selectedValue) => this.onChangeAlertType(selectedValue.id)}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <VirtualizedTable
                                                tableSettings={tableSettings}
                                                tableColumns={tableColumns}
                                                tableData={tableData}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const projectsReducer = state.projects;
    const alertsReducer = state.alerts;

    // Projects
    let projects = projectsReducer.get('payload') || List([]);

    if (!(projects instanceof List)) {
        projects = List([])
    }

    // Alerts
    let alerts = alertsReducer.get('payload') || List([]);

    if (!(alerts instanceof List)) {
        alerts = List([])
    }

    return {
        projects,
        alerts
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getProjects: (query) => dispatch(getProjects(query)),
        getAlerts: (alertType) => dispatch(getAlerts(alertType)),
        changeStatusAlert: (alertId, status) => dispatch(changeStatusAlert(alertId, status)),
        cleanProjects: () => dispatch(cleanProjects()),
        cleanAlerts: () => dispatch(cleanAlerts())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/containers/HomePage.js